import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  // Keyed by event type (data.type from server publications).
  // Components read from here and call clearWsEvent when done.
  wsEvents: {},

  // Reflects the Centrifuge connection state:
  // 'disconnected' | 'connecting' | 'connected'
  connectionStatus: "disconnected",
};

export const webSocketSlice = createSlice({
  name: "websocket",
  initialState,
  reducers: {
    // Replace the entire wsEvents map (used by clearWsEvent)
    setWsEvents: (state, action) => {
      state.wsEvents = action.payload;
    },
    // Merge a single typed event — avoids stale-closure issues when many
    // publications arrive in rapid succession from the Centrifuge bus.
    setSingleWsEvent: (state, action) => {
      const { eventType, data } = action.payload;
      state.wsEvents[eventType] = data;
    },
    setWsConnectionStatus: (state, action) => {
      state.connectionStatus = action.payload;
    },
  },
});

export const { setWsEvents, setSingleWsEvent, setWsConnectionStatus } =
  webSocketSlice.actions;
